var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, Box as MuiBox, styled } from '@mui/material';
import { ThemeUtils, getAttributes } from '../../../utils';
import { Text } from '../../atoms/text';
import { Icon, IconSizes } from '../../atoms/icon';
import { Image } from '../../atoms/image';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerPaddings } from '../../templates/container';
var MuiAccordionList = styled(MuiBox, {
    name: 'MuiAccordionList',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var A = function (_a) {
    var props = __rest(_a, []);
    var items = props.items, summary = props.summary, className = props.className, rest = __rest(props, ["items", "summary", "className"]);
    var mainConfig = __assign({ className: className }, getAttributes(rest));
    var summaryConfig = {
        expandIcon: React.createElement(Icon, { image: "pmi-icon-chevrondown", size: IconSizes.Small })
    };
    var summaryContainerConfig = {
        padding: ThemeUtils.getResponsiveProp([
            {
                y: ContainerPaddings.Size_4,
                l: ContainerPaddings.Size_4
            }
        ]),
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexGap: ContainerFlexGaps.Size_3,
        flexAlignItems: ContainerFlexAlignItems.Center
    };
    var getDefaultExpandedValue = function (item) {
        if (typeof item.defaultExpanded !== 'undefined') {
            return item.defaultExpanded;
        }
        return (items === null || items === void 0 ? void 0 : items.length) === 1;
    };
    return (React.createElement(MuiAccordionList, __assign({}, mainConfig), items === null || items === void 0 ? void 0 : items.map(function (item, index) {
        var _a;
        var titleProps = item.titleProps, children = item.children, itemRest = __rest(item, ["titleProps", "children"]);
        var itemConfig = __assign(__assign(__assign({ key: "accordion-".concat(index), defaultExpanded: getDefaultExpandedValue(item) }, ((item === null || item === void 0 ? void 0 : item.onToggle)
            ? {
                onChange: function (event, expanded) { var _a; return (_a = item.onToggle) === null || _a === void 0 ? void 0 : _a.call(item, event, expanded); }
            }
            : {})), (index > 0 ? { className: 'bordered' } : {})), getAttributes(itemRest));
        var summaryImageConfig = __assign({}, titleProps === null || titleProps === void 0 ? void 0 : titleProps.imageProps);
        var summaryTextConfig = {
            content: titleProps ? "<b>".concat(titleProps === null || titleProps === void 0 ? void 0 : titleProps.title, "</b>") : '',
            isHtml: true
        };
        var detailsConfig = {};
        return (React.createElement(MuiAccordion, __assign({}, itemConfig),
            summary || (React.createElement(MuiAccordionSummary, __assign({}, summaryConfig),
                React.createElement(Container, __assign({}, summaryContainerConfig),
                    (titleProps === null || titleProps === void 0 ? void 0 : titleProps.imageProps) && ((_a = titleProps === null || titleProps === void 0 ? void 0 : titleProps.imageProps) === null || _a === void 0 ? void 0 : _a.src) ? (React.createElement(Image, __assign({}, summaryImageConfig))) : null,
                    (titleProps === null || titleProps === void 0 ? void 0 : titleProps.title) ? React.createElement(Text, __assign({}, summaryTextConfig)) : null))),
            React.createElement(MuiAccordionDetails, __assign({}, detailsConfig), children)));
    })));
};
export { A as Accordion };
